import { OutputLocationsFetcher } from './OutputLocationsFetcher';
import { OutputLocations } from './OutputLocations';
import { ContainerInputProps } from '@/app/features/products/common/components/input-props';
import { useDataStore } from '@/app/core/components/step-wizard';
import { useEffect, useState } from 'react';
import { outputLocationsInfoValidator } from '@ssar-app/domain';

export const OutputLocationsContainer = (props: ContainerInputProps) => {
  const [subCode, setSubCode] = useState<string>('');
  const { keys } = props;
  const { data } = useDataStore();

  useEffect(() => {
    if (data?.subCode !== '') {
      setSubCode(data?.subCode);
    }
  }, [data?.subCode]);

  return (
    <>
      {subCode !== '' && (
        <OutputLocationsFetcher
          subCode={subCode}
          onSuccess={(clientAttributes, isLoading) => {
            return (
              <OutputLocations
                stepKey={keys}
                moduleProps={{
                  clientAttributes: clientAttributes,
                  isLoading: isLoading,
                }}
                validator={outputLocationsInfoValidator}
              />
            );
          }}
          onError={(error) => {
            console.error(error);
          }}
        />
      )}
    </>
  );
};
